// assets
import { IconFileText } from "@tabler/icons";
import helloworld from "../json/helloworld";
import websitecontent from "../json/websitecontent";
import articlegeneration from "../json/articlegeneration";
import headlinegeneration from "../json/headlinegeneration";
import metadescriptionsgeneration from "../json/metadescriptionsgeneration";
import generatefaqs from "../json/generatefaqs";
import socialmediapostsgeneration from "../json/socialmediapostsgeneration";
import avoidduplication from "../json/avoidduplication";
import performsentimentanalysis from "../json/performsentimentanalysis";
import summaryforcontent from "../json/summaryforcontent";
import semanticrelevance from "../json/semanticrelevance";
import gatherfactsandstatistics from "../json/gatherfactsandstatistics";

// constant
const icons = {
  IconFileText,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const contentgeneration = {
  id: "contentgeneration",
  title: "Content Generation",
  caption: "Content Generation",
  type: "group",
  children: [
    {
      id: "contentgeneration",
      title: "Content Generation",
      type: "collapse",
      icon: icons.IconFileText,

      children: [
        {
          
          id: "website-content-generation",
          title: "Website content generation",
          titleType: "collapse",
          type: "item",
          url: "/website-content-generation",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/metaDescription",
          jsonobject: websitecontent,
          editorTitile:
            "A well-written and informative website content ready to be published on the website",
          mainTitile: "Website content generation",
          mainDescription:
            "This feature enables you to input a topic or keyword of your choice, and the app will generate website content for you.",
        },
        {
          id: "article-generation",
          title: "Article generation",
          titleType: "collapse",
          type: "item",
          url: "/article-generation",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/articlegeneration",
          jsonobject: articlegeneration,
          editorTitile:
            "A well-written and informative article on the input topic",
          mainTitile: "Article generation",
          mainDescription:
            "This feature enables you to input a topic or keyword of your choice, and the app will generate an article for you.",
        },
        {
          id: "headline-generation",
          title: "Headline generation",
          titleType: "collapse",
          type: "item",
          url: "/headline-generation",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/titleTags",
          jsonobject: headlinegeneration,
          editorTitile:
            "A catchy and attention-grabbing headline on the input topic",
          mainTitile: "Headline generation",
          mainDescription:
            "This feature enables you to input a topic or keyword, and the app will generate headlines on that topic",
        },
        {
          id: "meta-descriptions-generation",
          title: "Meta descriptions generation",
          titleType: "collapse",
          type: "item",
          url: "/meta-descriptions-generation",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/metaDescriptionGen",
          jsonobject: metadescriptionsgeneration,
          editorTitile: "Meta descriptions for the website's pages",
          mainTitile: "Meta descriptions generation",
          mainDescription:
            "This feature enables you to input a website's URL, and the app will generate meta descriptions for that website's pages.",
        },
        {
          id: "social-media-posts-generation",
          title: "Social Media posts generation",
          titleType: "collapse",
          type: "item",
          url: "/social-media-posts-generation",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/socialMediaPost",
          jsonobject: socialmediapostsgeneration,
          editorTitile:
            "A well-written and engaging social media post on the input topic",
          mainTitile: "Social Media posts generation",
          mainDescription:
            "This feature enables you to input a topic or keyword, and the app will generate social media posts on that topic",
        },
        {
          id: "avoid-duplication",
          title: "Rephrase your existing content to avoid duplication",
          titleType: "collapse",
          type: "item",
          url: "/avoid-duplication",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/rephrase",
          jsonobject: avoidduplication,
          editorTitile:
            "Slightly rephrased website content to avoid duplication",
          mainTitile: "Rephrase your existing content to avoid duplication",
          mainDescription:
            "This feature enables you to input existing website content, and the app will rephrase it slightly to avoid duplication while maintaining the original meaning.",
        },
        {
          id: "generate-faqs",
          title: "Generate FAQs",
          titleType: "collapse",
          type: "item",
          url: "/generate-faqs",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/faq",
          jsonobject: generatefaqs,
          editorTitile:
            "A list of frequently asked questions and answers on the input topic",
          mainTitile: "Generate FAQs",
          mainDescription:
            "This feature enables you to input a topic or keyword, and the app will generate a list of frequently asked questions and answers on that topic.",
        },
        {
          id: "gather-factsand-statistics",
          title: "Gather facts and statistics to support your content",
          titleType: "collapse",
          type: "item",
          url: "/gather-factsand-statistics",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/statsandfacts",
          jsonobject: gatherfactsandstatistics,
          editorTitile:
            "A list of relevant statistics and facts that can be used to support content claims within the article or website page",
          mainTitile: "Gather facts and statistics to support your content",
          mainDescription:
            "This feature would allow users to gather relevant data and statistics to back up the information",
        },
        {
          id: "semantic-relevance",
          title: "Cluster articles based on semantic relevance of their titles",
          titleType: "collapse",
          type: "item",
          url: "/semantic-relevance",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/semanticrelevance",
          jsonobject: semanticrelevance,

          editorTitile:
            "Clusters of article titles grouped based on semantic relevance.",
          mainTitile:
            "Cluster articles based on semantic relevance of their titles",
          mainDescription:
            "This feature enables you to input a set of article titles, and the app will group them into clusters based on their semantic relevance.",
        },

        {
          id: "summary-your-content",
          title: "Generate a summary of your content",
          titleType: "collapse",
          type: "item",
          url: "/summary-your-content",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/contentsummary",
          jsonobject: summaryforcontent,
          editorTitile:
            "A condensed version of the input content, highlighting the main points and key takeaways.",
          mainTitile: "Generate a summary of your content",
          mainDescription:
            "This feature enables you to input a piece of content, and the app will generate a summary of that content.",
        },
        {
          id: "perform-sentiment-analysis",
          title: "Perform sentiment analysis",
          titleType: "collapse",
          type: "item",
          url: "/perform-sentiment-analysis",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/sentimentanalysis",
          jsonobject: performsentimentanalysis,
          editorTitile:
            "Sentiment analysis report including sentiment score and classification as positive, neutral, or negative.",
          mainTitile: "Perform sentiment analysis",
          mainDescription:
            "This feature would allow users to input a piece of text, and the app would analyze the sentiment of the text using natural language processing techniques. The sentiment can be positive, neutral, or negative.",
        },
      ],
    },
  ],
};

export default contentgeneration;
